import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import HoverableOpacity from "../components/HoverableOpacity";

class Pagination extends Component {
    constructor(props) {
        super(props);

        this.state = {
            list: [
                {
                    id: 1,
                    code: 'Introduction',
                },
                {
                    id: 2,
                    code: 'Getting Started',
                },
                {
                    id: 3,
                    code: 'M18 Search',
                },
                {
                    id: 4,
                    code: 'Creating Module Data with SqlEntity',
                },
                {
                    id: 5,
                    code: 'Editing(Read/Update/Delete) Module Data\nwith SqlEntity',
                },
                // {
                //     id: 6,
                //     code: 'Appendix 1',
                // },
                {
                    id: 7,
                    code: 'Appendix 1 - Stock Level',
                },
                {
                    id: 8,
                    code: 'Appendix 2 - Outstanding AR/AP ',
                }
            ],
        }
    }

    render() {
        return (
            <View style={styles.container}>
                {this.state.list.map((item, index) => (
                    <View key={item.id} style={
                        (this.props.selectId === item.id) ? [styles.content, styles.selectContent] : styles.content
                    }>
                        <HoverableOpacity
                            hoverstyle={styles.hoverStyle}
                            outerstyle={
                                (this.props.selectId === item.id)
                                    ? styles.clicked : ''
                            }
                            style={styles.touchableStyle}
                            textvalue={item.code}
                            onPress={() => {
                                this.props.onPress(item.id);
                            }}>
                        </HoverableOpacity>
                    </View>
                ))}
            </View>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        width: 350,
    },
    content: {
        flexDirection: 'row',
        padding: 20,
    },
    selectContent: {
        borderLeftWidth: 6,
        borderColor: '#c8e1ff',
    },
    hoverStyle: {
        fontWeight: 'bold',
        textDecorationLine: 'underline',
    },
    touchableStyle: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    clicked: {
        fontWeight: 'bold',
        textDecorationLine: 'underline',
    },
})

export default Pagination;



// WEBPACK FOOTER //
// ./src/pages/Pagination.js